var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      style: { display: "grid", "margin-top": _vm.edit == true ? "0" : "2rem" },
    },
    [
      _vm.edit == false
        ? _c(
            "button",
            {
              staticClass: "btn-outline btn-dark",
              on: {
                click: function ($event) {
                  return _vm.openModal()
                },
              },
            },
            [
              _c("i", { staticClass: "fa-light fa-plus" }),
              _vm._v("Add payment"),
            ]
          )
        : _c("i", {
            staticClass: "fa-regular fa-pen-to-square",
            on: {
              click: function ($event) {
                return _vm.openModal()
              },
            },
          }),
      _vm._v(" "),
      _vm.isModalOpen
        ? _c("div", { staticClass: "modal-container" }, [
            _c("div", { staticClass: "modal-content" }, [
              _c("h1", [
                _vm._v(
                  _vm._s(_vm.edit == true ? "Edit Payment" : "Add Payment")
                ),
                _c("i", {
                  staticClass: "fa-regular fa-xmark",
                  on: {
                    click: function ($event) {
                      return _vm.closeModal()
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "span",
                { staticStyle: { "font-weight": "normal", color: "#717182" } },
                [
                  _vm._v(
                    _vm._s(
                      _vm.edit == true
                        ? "Modify the details of the selected payment. Payment date must be today or in the past."
                        : "Create a new payment to add to the queue. Payment date must be today or in the past."
                    )
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticStyle: { display: "grid" } }, [
                _c("span", { staticClass: "filter-item-title" }, [
                  _vm._v("VIBAN*"),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.newPayment.VIBAN,
                      expression: "newPayment.VIBAN",
                    },
                  ],
                  staticClass: "filter-item-content",
                  attrs: { type: "text", placeholder: "VIBAN..." },
                  domProps: { value: _vm.newPayment.VIBAN },
                  on: {
                    input: [
                      function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.newPayment, "VIBAN", $event.target.value)
                      },
                      function (event) {
                        return (_vm.newPayment.VIBAN = _vm.sanitize(
                          event.target.value
                        ))
                      },
                    ],
                  },
                }),
                _vm._v(" "),
                _c("small", [_vm._v("Must be a VIBAN from the VIBAN pool")]),
                _vm._v(" "),
                _vm.VIBANerror
                  ? _c(
                      "small",
                      { staticStyle: { color: "#e7000b", display: "flex" } },
                      [_vm._v(_vm._s(_vm.VIBANerror))]
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticStyle: { display: "grid" } }, [
                _c("span", { staticClass: "filter-item-title" }, [
                  _vm._v("Amount (EUR)*"),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.number",
                      value: _vm.newPayment.amount,
                      expression: "newPayment.amount",
                      modifiers: { number: true },
                    },
                  ],
                  staticClass: "filter-item-content",
                  attrs: {
                    type: "number",
                    placeholder: "0.00",
                    step: "0.01",
                    min: "0",
                  },
                  domProps: { value: _vm.newPayment.amount },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.newPayment,
                        "amount",
                        _vm._n($event.target.value)
                      )
                    },
                    blur: function ($event) {
                      return _vm.$forceUpdate()
                    },
                  },
                }),
                _vm._v(" "),
                _vm.amountError
                  ? _c(
                      "small",
                      { staticStyle: { color: "#e7000b", display: "flex" } },
                      [_vm._v(_vm._s(_vm.amountError))]
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { display: "grid" } },
                [
                  _c("span", { staticClass: "filter-item-title" }, [
                    _vm._v("Payment Date*"),
                  ]),
                  _vm._v(" "),
                  _c("datetime-picker", {
                    staticClass: "z-1",
                    class: {
                      "filter-item-input": true,
                      "filter-item-input-complete": _vm.newPayment.date,
                      "error-datepicker": _vm.dateError,
                    },
                    attrs: {
                      format: "DD/MM/YYYY",
                      customInputParentClass: "filter-item-content",
                      maxLength: 19,
                      placeholderValue: _vm.$t(
                        "common.datetime_picker_empty_date"
                      ),
                      inputIcon: "fa-solid fa-calendar",
                    },
                    model: {
                      value: _vm.newPayment.date,
                      callback: function ($$v) {
                        _vm.$set(_vm.newPayment, "date", $$v)
                      },
                      expression: "newPayment.date",
                    },
                  }),
                  _vm._v(" "),
                  _vm.dateError
                    ? _c("span", { staticClass: "text-danger" }, [
                        _vm._v("Please enter a valid date"),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("small", [_vm._v("Date must be today or in the past")]),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticStyle: { display: "grid" } }, [
                _c("span", { staticClass: "filter-item-title" }, [
                  _vm._v("Payment Reference"),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.newPayment.reference,
                      expression: "newPayment.reference",
                    },
                  ],
                  staticClass: "filter-item-content",
                  attrs: {
                    type: "text",
                    placeholder: "Payment reference (optional)",
                  },
                  domProps: { value: _vm.newPayment.reference },
                  on: {
                    input: [
                      function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.newPayment,
                          "reference",
                          $event.target.value
                        )
                      },
                      function (event) {
                        return (_vm.newPayment.reference = _vm.sanitize(
                          event.target.value
                        ))
                      },
                    ],
                  },
                }),
                _vm._v(" "),
                _c("small", [
                  _vm._v("Optional - can help identify the payment purpose"),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "end",
                    "align-items": "center",
                    gap: "1rem",
                    "margin-top": "2rem",
                  },
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn-outline-light btn",
                      on: {
                        click: function ($event) {
                          return _vm.closeModal()
                        },
                      },
                    },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _vm.edit == false
                    ? _c(
                        "button",
                        {
                          staticClass: "btn-outline btn-dark",
                          on: {
                            click: function ($event) {
                              return _vm.addToQueue()
                            },
                          },
                        },
                        [_vm._v("Add to Queue")]
                      )
                    : _c(
                        "button",
                        {
                          staticClass: "btn-outline btn-dark",
                          on: {
                            click: function ($event) {
                              return _vm.save()
                            },
                          },
                        },
                        [_vm._v("Save Changes")]
                      ),
                ]
              ),
            ]),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }